import { createTheme } from '@mui/material/styles';
import { COLORS } from '../../../utils/Application_Constants';

const datePickerTheme = createTheme({
    components: {
        MuiIconButton: {
            styleOverrides: {
                sizeMedium: {
                    color: COLORS.LT_JOURNEY,
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'inherit',
                    fontSize: 'inherit',
                    fontWeight: '700',
                    marginLeft: '0px',
                    textTransform: 'capitalize',
                    fontFamily: 'museo-sans',
                },
                formControl: {
                    transform: 'none',
                    position: 'inherit',
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                borderRadius: '0px',
                underline: {
                    '&:before': {
                        content: 'none',
                    },
                    '&:after': {
                        boxShadow: COLORS.WHITE_LILAC,
                        // borderColor: COLORS.RAVEN,
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                subtitle1: {
                    'text-decoration': 'underline',
                    'font-weight': 'bold',
                },
                colorPrimary: {
                    color: COLORS.LT_JOURNEY,
                },
            },
        },
        MuiPickersToolbar: {
            styleOverrides: {
                toolbar: {
                    'background-color': COLORS.LT_JOURNEY,
                },
            },
        },
        MuiPickersDay: {
            styleOverrides: {
                daySelected: {
                    'background-color': COLORS.LT_JOURNEY,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontFamily: 'museo-sans',
                    color: `${COLORS.LT_MIDNIGHT}!important`,
                    borderRadius: '0px',
                    transition: 'all 0.3s',
                    '& .MuiOutlinedInput-notchedOutline': {
                        color: COLORS.LT_MIDNIGHT,
                        border: '1px solid #e7e7e7!important',
                        transition: 'all 0.3s',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #0077C8!important',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #0077C8!important',
                    },
                    '&&& .MuiInputBase-input': {
                        padding: '12px',
                    },
                },
            },
        },
    },
});
export default datePickerTheme;
